module.exports = __webpack_public_path__ + "img/boleto-barcode-dark.3f560575.svg";